import { getNumericIdFromStringLocationId } from "./locationUtils";
import { worldGroupDatum } from "../graphql/queries/getLocationsMetadata";
import { getLocationQualifiers } from "./locationUtils";
import { UIView } from "../types/vizEnums";

/** Return type of mapQueryArgumentsToAPIEndpointInputs — all IDs are numeric after conversion */
export interface NarrowedLocationVariables {
  countryId: number | undefined;
  groupId: number | undefined;
  partnerCountryId: number | undefined;
  partnerGroupId: number | undefined;
}

export const mapQueryArgumentsToAPIEndpointInputs = ({
  exporter,
  importer,
  view,
}: {
  exporter: string;
  importer: string;
  view: UIView;
}): NarrowedLocationVariables => {
  const {
    exporterIsUndefined,
    exporterIsWorld,
    exporterIsGroup,
    exporterIsCountry,
    importerIsUndefined,
    importerIsWorld,
    importerIsGroup,
    importerIsCountry,
  } = getLocationQualifiers({ exporter, importer });
  let countryId: string | undefined = undefined;
  let partnerCountryId: string | undefined = undefined;
  let groupId: string | undefined = undefined;
  let partnerGroupId: string | undefined = undefined;

  if (view === UIView.Products) {
    if (!exporterIsUndefined && !importerIsUndefined) {
      if (!exporterIsWorld && !importerIsWorld) {
        if (exporterIsCountry && importerIsCountry) {
          countryId = exporter;
          partnerCountryId = importer;
        } else if (exporterIsCountry && importerIsGroup) {
          countryId = exporter;
          partnerGroupId = importer;
        } else if (exporterIsGroup && importerIsCountry) {
          groupId = exporter;
          partnerCountryId = importer;
        } else if (exporterIsGroup && importerIsGroup) {
          groupId = exporter;
          partnerGroupId = importer;
        }
      } else if (exporterIsWorld && !importerIsWorld) {
        if (importerIsCountry) {
          countryId = importer;
        } else if (importerIsGroup) {
          groupId = importer;
          partnerGroupId = worldGroupDatum.groupId;
        }
      } else if (!exporterIsWorld && importerIsWorld) {
        if (exporterIsCountry) {
          countryId = exporter;
        } else if (exporterIsGroup) {
          groupId = exporter;
          partnerGroupId = worldGroupDatum.groupId;
        }
      } else if (exporterIsWorld && importerIsWorld) {
        groupId = worldGroupDatum.groupId;
        partnerGroupId = worldGroupDatum.groupId;
      }
    } else if (!exporterIsUndefined && importerIsUndefined) {
      if (exporterIsWorld) {
        // Trigger CPY with countryId undefined
      } else if (exporterIsCountry) {
        countryId = exporter;
      } else if (exporterIsGroup) {
        // No-op for group without importer
      }
    } else if (exporterIsUndefined && !importerIsUndefined) {
      if (importerIsWorld) {
        // Trigger CPY with countryId undefined
      }
    }
  } else if (view === UIView.Markets) {
    if (
      !exporterIsWorld &&
      !importerIsWorld &&
      !exporterIsUndefined &&
      !importerIsUndefined
    ) {
      if (exporterIsCountry && importerIsCountry) {
        countryId = exporter;
        partnerCountryId = importer;
      } else if (exporterIsCountry && importerIsGroup) {
        countryId = exporter;
        partnerGroupId = importer;
      } else if (exporterIsGroup && importerIsCountry) {
        groupId = exporter;
        partnerCountryId = importer;
      } else if (exporterIsGroup && importerIsGroup) {
        groupId = exporter;
        partnerGroupId = importer;
      }
    } else if (exporterIsWorld && !importerIsUndefined && !importerIsWorld) {
      if (importerIsCountry) {
        countryId = importer;
      } else if (importerIsGroup) {
        groupId = importer;
      }
    } else if (!exporterIsWorld && !exporterIsUndefined && importerIsWorld) {
      if (exporterIsCountry) {
        countryId = exporter;
      } else if (exporterIsGroup) {
        groupId = exporter;
      }
    } else if (
      (exporterIsWorld && importerIsWorld) ||
      (exporterIsWorld && importerIsUndefined) ||
      (exporterIsUndefined && importerIsWorld)
    ) {
      groupId = worldGroupDatum.groupId;
    }
  }

  return {
    countryId: countryId
      ? getNumericIdFromStringLocationId(countryId)
      : undefined,
    groupId: groupId ? getNumericIdFromStringLocationId(groupId) : undefined,
    partnerCountryId: partnerCountryId
      ? getNumericIdFromStringLocationId(partnerCountryId)
      : undefined,
    partnerGroupId: partnerGroupId
      ? getNumericIdFromStringLocationId(partnerGroupId)
      : undefined,
  };
};
